export const ADD_LCD = "ADD_LCD";
export const REMOVE_LCD = "REMOVE_LCD";
export const ACTIVE_LCD = "ACTIVE_LCD";
export const LOGIN_LOGOUT_USER = "LOGIN_LOGOUT_USER";
export const LOADER_DISPLAY_HIDE = "LOADER_DISPLAY_HIDE";
export const SET_LANGUAGE = "SET_LANGUAGE";
export const ACTIVE_DEAL_ADVERTISEMENT = "ACTIVE_DEAL_ADVERTISEMENT";